import {getConfig} from 'config';
import {getData} from '../dataProvider';

export const loadPreLaunchChecks = () => {
  return getData(`${getConfig('preLaunchChecksUrl')}`);
};
